import { ImageType } from 'types'

import img_000 from './0.png'
import img_001 from './1.png'
import img_002 from './2.png'
import img_003 from './3.png'
import img_004 from './4.png'
import img_005 from './5.png'
import img_006 from './6.png'
import img_007 from './7.png'
import img_008 from './8.png'
import img_009 from './9.png'
import img_010 from './10.png'
import img_011 from './11.png'
import img_012 from './12.png'
import img_013 from './13.png'
import img_014 from './14.png'
import img_015 from './15.png'
import img_016 from './16.png'
import img_017 from './17.png'
import img_018 from './18.png'
import img_019 from './19.png'
import img_020 from './20.png'
import img_021 from './21.png'
import img_022 from './22.png'
import img_023 from './23.png'
import img_024 from './24.png'
import img_025 from './25.png'
import img_026 from './26.png'
import img_027 from './27.png'
import img_028 from './28.png'
import img_029 from './29.png'
import img_030 from './30.png'
import img_031 from './31.png'
import img_032 from './32.png'
import img_033 from './33.png'
import img_034 from './34.png'
import img_035 from './35.png'
import img_036 from './36.png'
import img_037 from './37.png'

const defaultStyle = {
  height: 0,
  top: 0,
  bottom: 0,
  backgroundImage: '',
  backgroundPosition: '',
}

export const images: ImageType[] = [
  { id: 'img_000', src: img_000, backName: 'a', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_001', src: img_001, backName: 'a', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_002', src: img_002, backName: 'a', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_003', src: img_003, backName: 'a', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_004', src: img_004, backName: 'a', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_005', src: img_005, backName: 'a', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_006', src: img_006, backName: 'a', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_007', src: img_007, backName: 'a', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_008', src: img_008, backName: 'a', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_009', src: img_009, backName: 'a', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_010', src: img_010, backName: 'a', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_011', src: img_011, backName: 'a', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_012', src: img_012, backName: 'a', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_013', src: img_013, backName: 'a', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_014', src: img_014, backName: 'a', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_015', src: img_015, backName: 'a', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_016', src: img_016, backName: 'a', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_017', src: img_017, backName: 'b', frameName: 'dark', style: { ...defaultStyle } },
  { id: 'img_018', src: img_018, backName: 'b', frameName: 'dark', style: { ...defaultStyle } },
  { id: 'img_019', src: img_019, backName: 'b', frameName: 'dark', style: { ...defaultStyle } },
  { id: 'img_020', src: img_020, backName: 'b', frameName: 'dark', style: { ...defaultStyle } },
  { id: 'img_021', src: img_021, backName: 'b', frameName: 'dark', style: { ...defaultStyle } },
  { id: 'img_022', src: img_022, backName: 'c', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_023', src: img_023, backName: 'c', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_024', src: img_024, backName: 'c', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_025', src: img_025, backName: 'c', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_026', src: img_026, backName: 'c', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_027', src: img_027, backName: 'c', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_028', src: img_028, backName: 'c', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_029', src: img_029, backName: 'c', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_030', src: img_030, backName: 'c', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_031', src: img_031, backName: 'c', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_032', src: img_032, backName: 'c', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_033', src: img_033, backName: 'c', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_034', src: img_034, backName: 'c', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_035', src: img_035, backName: 'c', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_036', src: img_036, backName: 'c', frameName: 'light', style: { ...defaultStyle } },
  { id: 'img_037', src: img_037, backName: 'c', frameName: 'light', style: { ...defaultStyle } },
]

images.forEach(img => {
  img.style = {
    backgroundImage: `url("${img.src}")`,
    height: 0,
    top: '',
    bottom: 0,
    backgroundPosition: 'bottom',
  }
})

images[0].style = {
  ...images[0].style,
  height: 'auto',
  top: 0,
  bottom: '',
  backgroundPosition: 'top',
}
